<!--教师年龄-->
<template>
    <div class="my-charts">
        <div :id="id" style="margin-top: -40px"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";

export default {
    name: "teaZcEcharts",
    props: {
        id:{
            type: String,
            default:"tea_zc_echarts"
        },
        teaCount:{
            type: Number,
            default: 0
        },
        rank1Count:{
            type: Number,
            default: 0
        },
        rank2Count:{
            type: Number,
            default: 0
        },
        rank3Count:{
            type: Number,
            default: 0
        },
        rank4Count:{
            type: Number,
            default: 0
        },
        rank5Count:{
            type: Number,
            default: 0
        },
        rank6Count:{
            type: Number,
            default: 0
        },
    },
    watch:{
        id(newValue,oldValue){
            this.id = newValue;
        },
    },
    data() {
        return {
            pieChart: null, // 饼图
            chartOption:{
                title: {
                    show:false,
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    show: true,
                    bottom:0,
                    width:'100%',
                    textStyle: { 
                        color: '#fff',
                        rich:{
                            a:{
                                width:140
                            }
                        }
                    },
                    formatter: ['{a|{name}}'].join('\n'),
                },
                graphic: [
                    {
                        type: "text",
                        left: "center",
                        top: "center",
                        style: {
                            text: '',
                            textAlign: "center",
                            fill: "#ffffff",
                            lineHeight:30,
                            fontSize: 20,
                            fontWeight: 'bold'
                        },
                    },
                ],
                series: [
                    {
                        name: '教师年龄：',
                        type: 'pie',
                        radius: ['55%', '80%'],
                        color: [
                            '#91cc75',
                            '#fac858',
                            '#ee6666',
                            '#3ba272',
                            '#fc8452',
                            '#9a60b4',
                            '#ea7ccc',
                        ],
                        label: {
                            show: false,
                            position: 'right'
                        },
                        labelLine: {
                            show: true
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            const list = []
            list.push({'value':this.rank1Count,'name':"正高级教师"});
            list.push({'value':this.rank2Count,'name':"高级教师"});
            list.push({'value':this.rank3Count,'name':"一级教师"});
            list.push({'value':this.rank4Count,'name':"二级教师   "});
            list.push({'value':this.rank5Count,'name':"三级教师"});
            list.push({'value':this.rank6Count,'name':"其他"});
            this.pieChart = echarts.init(document.getElementById(this.id));
            this.chartOption.series[0].data = []
            this.chartOption.series[0].data = list;
            this.chartOption.graphic[0].style.text = this.teaCount+'\n'+"注册教师"
            this.pieChart.setOption(this.chartOption);
        }
    }
};
</script>

<style scoped lang="scss">
.my-charts {
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh);
    }
}
</style>